import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Config } from '../_store';
@Injectable({
  providedIn: 'root'
})
export class ObjectTransformService {

  private _param1 = ""; //key
  private _param2 = ""; //salt
  private _param3 = ""; //iv
  private _finalParam = "";
  private _transformOptions: any = {};

  private _fnTransformUI = CryptoJS.AES.encrypt;
  private _fnTransformService = CryptoJS.AES.decrypt;
  private _transformEnc = CryptoJS.enc.Base64;
  private _transformDec = CryptoJS.enc.Utf8;
  private _transformHexEnc = CryptoJS.enc.Hex;
  private _fnTransformOneWay = CryptoJS.SHA256;
  private plainTranformParam1 = ['D', '5', 'D', '6', 'E', '3', '7', 'C', '9', 'A', '8', 'F', '4', '7', '4', 'F', '0', 'F', '2', 'D', 'A', 'C', '1', 'F', '9', '6', 'E', '3', '2', 'E', 'D', '9', '3', '0', '2', 'E', '9', '9', 'B', '9'].join('');
  private plainTranformParam2 = ['0', '0', '0', '0', '0', '1', '1', '5', '2', '5', 'F', 'P', 'S', 'L', 'T'].join('');
  private plainTranformParam3 = ['G', 'L', 'O', 'B', 'A', 'L', 'P', 'A', 'Y', 'E', 'X', 'E', 'N', 'C', 'S', 'E', 'R', 'V', 'I', 'C', 'E'].join('');
  constructor() {
    this.init();
  }

  init() {
    // const orgStr = "EF737CC29DAE7C80644A5B01544CBA61|||12345|||79994A6EF73DA76C"
    // const transformed = this.plainTransform(orgStr, this.plainTranformParam1, this.plainTranformParam2, this.plainTranformParam3);
    // console.log(transformed);
    const transformedParams = this.plainReverse(Config.transformParam, this.plainTranformParam1, this.plainTranformParam2, this.plainTranformParam3).split('|||');
    this._param1 = transformedParams[0];
    this._param2 = transformedParams[1];
    this._param3 = transformedParams[2];
    this._finalParam = CryptoJS.PBKDF2(this._param1, this._param2, {
      keySize: 256 / 32,
      iterations: 65536 / 32
    });
    this._transformOptions = {
      iv: this.toWordArray(this._param3),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    };
    
  }

  encoder(str) {
    let encoder = new TextEncoder();
    let byteArray = encoder.encode(str)
    return CryptoJS.enc.Utf8.parse(str)
  }

  toWordArray(str) {
    return CryptoJS.enc.Utf8.parse(str);
  }

  transformUI(value) {
    var transformed = this._fnTransformUI(this.encoder(value), this._finalParam, this._transformOptions)
    return transformed.ciphertext.toString(this._transformEnc);
  }

  transformService(value) {
    var transformed = this._fnTransformService(value, this._finalParam, this._transformOptions);
    return transformed.toString(this._transformDec);
  }

  transformOneWay(str) {
    return this._fnTransformOneWay(str).toString(this._transformHexEnc);
  }

  private plainTransform(value, key, salt, iv) {
    const finalParam = CryptoJS.PBKDF2(key, salt, {
      keySize: 256 / 32,
      iterations: 65536 / 32
    });
    const transformOptions = {
      iv: this.toWordArray(iv),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    };
    var transformed = this._fnTransformUI(this.encoder(value), finalParam, transformOptions)
    return transformed.ciphertext.toString(this._transformEnc);
  }

  private plainReverse(value, key, salt, iv) {
    const finalParam = CryptoJS.PBKDF2(key, salt, {
      keySize: 256 / 32,
      iterations: 65536 / 32
    });
    const transformOptions = {
      iv: this.toWordArray(iv),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    };
    var transformed = this._fnTransformService(value, finalParam, transformOptions);
    return transformed.toString(this._transformDec);
  }

}
